import React, { useState } from 'react';
import { Container, TabContent, TabPane } from 'reactstrap';
import Loading from '../../shared/components/custom/Loading';

import { partial } from '../../util/translation/translation';
import NavTab from '../../shared/components/custom/NavTab';
import QuestionaireListPage from './QuestionaireListPage';
import QuestionnairesShowcase from './components/QuestionnairesShowcase';
import QuestionListPage from './QuestionListPage';
import QuestionaireCategoryListPage from './QuestionaireCategoryListPage';

const QuestionairePage = () => {
  const [questionairesLoading, setQuestionairesLoading] = useState(true);
  const [questionsLoading, setQuestionsLoading] = useState(true);
  const [questionareCategoriesLoading, setQuestionareCategoriesLoading] =
    useState(true);
  const [tab, setTab] = useState(1);
  const p = partial('questionaire');
  return (
    <Container>
      <Loading
        loading={
          questionairesLoading ||
          questionsLoading ||
          questionareCategoriesLoading
        }
      />
      <QuestionnairesShowcase />
      <NavTab
        activeTab={tab}
        tabs={[
          p('questionaires'),
          p('questions'),
          p('questionaireCategories.questionaireCategories'),
        ]}
        setTab={setTab}
      />
      <TabContent activeTab={tab}>
        <TabPane tabId="1">
          <QuestionaireListPage setLoading={setQuestionairesLoading} />
        </TabPane>
        <TabPane tabId="2">
          <QuestionListPage setLoading={setQuestionsLoading} />
        </TabPane>
        <TabPane tabId="3">
          <QuestionaireCategoryListPage
            setLoading={setQuestionareCategoriesLoading}
          />
        </TabPane>
      </TabContent>
    </Container>
  );
};

export default QuestionairePage;
